import ApiEndpoints from '@/config/ApiEndpoints';
import { prepareUrl } from '@/helpers/UrlHelpers';
import ApiService from '@/services/ApiService';

export default class UpdateBillingAddress {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * UpdateBillingAddress constructor.
     *
     * @param {ApiService|null} apiService
     *
     * @returns {void}
     */
    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);

        this.apiService.enableAuth();
    }

    /**
     * Handle updating a users billing address.
     *
     * @param {number} userId
     * @param {number} addressId
     * @param {*}      payload
     *
     * @return {Promise}
     */
    handle(userId, addressId, payload) {
        let apiUrl = prepareUrl(ApiEndpoints['payments.address.update'], [userId, addressId]);

        let parameters = {
            first_name: payload.firstName,
            last_name: payload.lastName,
            address1: payload.address1,
            address2: payload.address2 || null,
            city: payload.city,
            postcode: payload.postcode,
            country: payload.country,
        };

        return this.apiService.patch(apiUrl, parameters);
    }
}
